import { Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NewAgendaComponent } from 'app/home/sidebar/newAgenda/new_agenda';
import { Agenda } from 'app/model/agenda';
import { OptionsComponent } from 'app/opzioni/opzioni';
import { OAuth2Service } from '../angular-rest';

@Component({
	selector: 'app-nav',
	templateUrl: './navbar.html',
	styleUrls: ['./navbar.css']
})
export class NavbarComponent {
	@Input()
	agenda: Agenda;

	@Input()
	disableNewEvent: boolean = false;

	@Output()
	onNewEvent = new EventEmitter<MouseEvent>();
	
	mobileView: boolean;

	constructor(
		private modalService: NgbModal,
		public auther: OAuth2Service
	) {
		this.mobileView = window.innerWidth < 768;
	}

	addAgenda() {
		const modalRef = this.modalService.open(NewAgendaComponent);
	}

	showGeneralSettings() {
		this.modalService.open(OptionsComponent);
	}

	print() {
		window.print();
	}
}



// WEBPACK FOOTER //
// ./src/app/navbar/navbar.ts